import { Component, ElementRef, HostListener, OnInit, ViewChild,Input, Output, EventEmitter } from '@angular/core';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { ConfigTableInterface } from 'src/app/shares/interfaces';
import { Action, Pagination, Types } from 'src/app/shares/constants';
import { AuthService } from 'src/app/shares/services';

interface ItemData {
    id: string;
    fullName: string;
    age: string;
    address: string;
}
@Component({
    selector: 'table-edit-cell',
    templateUrl: './table-edit-cell.component.html',
    styleUrls: ['./table-edit-cell.component.scss']
})
export class TableEditCellComponent {
    @Input() configTable: ConfigTableInterface;
    @Output() actionClicked = new EventEmitter<any>();
    i = 0;
    editId: string | null;
    listOfData: ItemData[] = [];
  
    dataTable: any[];
    searchValue: string = '';
    pageSize: number = Pagination.PageSize;
    pageIndex: number = Pagination.PageIndex;
    totalPage: number = 0;
    clientSize: boolean = false;
    constructor(private authService: AuthService) {
        this.dataTable = [];
    }
    @ViewChild(NzInputDirective, { static: false, read: ElementRef }) inputElement: ElementRef;

    @HostListener('window:click', ['$event'])
    handleClick(e: MouseEvent): void {
        if (this.editId && this.inputElement && this.inputElement.nativeElement !== e.target) {
        this.editId = null;
        }
    }

    setData(data, total, clientSize: boolean = false) {
        this.listOfData = data;
        this.configTable.Data = this.dataTable = data;
        this.totalPage = total;
        this.clientSize = false;
    }
deleteRow(id: string): void {
    this.listOfData = this.listOfData.filter(d => d.id !== id);
}

startEdit(id: string, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.editId = id;
}
checkPerAction(action) {
    if(action == Action.Back)
      return true;
    return this.authService.checkPermissionAction(action);
  }

ngOnInit(): void {

}
}
